import AppReq from '@/h5/utils/appActions/index'
import useAppStore from '@/h5/stores/app'
import { ref, reactive, onMounted, nextTick } from 'vue'
import Toast from '@/h5/components/toast'
import Loading from '@/h5/components/loading'
import useGlobalTimer from '@/packages/plugins/hook/useGlobalTimer'
import useComponentRef from '@/packages/plugins/hook/useComponent'
import LGSdk from '@/packages/plugins/languageSDK/index'

/** 世界杯竞猜 — 成功状态码 */
const SUCCESS_CODE = 1

/** 世界杯竞猜 — 业务错误码 */
const WORLD_CUP_ERROR_CODES = [4300001, 4300002, 4300003, 4300004, 4300005, 4300006, 4300007, 4300008, 4300009]

export const WORLD_CUP_EVENTS = [
  {
    name: 'getMatchList',
    label: '获取赛事列表'
  },
  {
    name: 'placeBet',
    label: '投注',
    params: [
      { label: '赛事ID', value: 'matchId' },
      { label: '投注金额', value: 'amount' }
    ]
  },
  {
    name: 'getBetRecords',
    label: '获取投注记录'
  },
  {
    name: 'getBetRecordsNextPage',
    label: '获取投注记录下一页'
  },
  {
    name: 'getBattleRecord',
    label: '获取我的战绩'
  },
  {
    name: 'getTodayRankList',
    label: '获取今日竞猜排行'
  },
  {
    name: 'getYesterdayRankList',
    label: '获取昨日竞猜排行'
  },
  {
    name: 'setSelectedDate',
    label: '设置选中日期',
    params: [{ label: '日期（M:DD）', value: 'date' }]
  },
  {
    name: 'prevDatePage',
    label: '上一页日期'
  },
  {
    name: 'nextDatePage',
    label: '下一页日期'
  },
  {
    name: 'setBetResult',
    label: '选择投注结果',
    params: [{ label: '投注选项', value: 'option', description: 'HOME_WIN / DRAW / AWAY_WIN' }]
  },
  {
    name: 'refreshCurrencyBalance',
    label: '刷新代币余额'
  }
]

const BET_OPTIONS = ['HOME_WIN', 'DRAW', 'AWAY_WIN']

export const WORLD_CUP_DATA_SOURCE = [
  { label: '活动代币ID', keys: 'worldCup.currencyId' },
  { label: '活动代币余额', keys: 'worldCup.currencyBalance' },
  { label: '最低投注额', keys: 'worldCup.minBetAmount' },
  { label: '赛事列表', keys: 'worldCup.matches' },
  { label: '赛事列表-赛事ID', keys: 'worldCup.matches[].matchId' },
  { label: '赛事列表-主队名称', keys: 'worldCup.matches[].homeTeamName' },
  { label: '赛事列表-客队名称', keys: 'worldCup.matches[].awayTeamName' },
  { label: '赛事列表-主队Logo', keys: 'worldCup.matches[].homeTeamLogo' },
  { label: '赛事列表-客队Logo', keys: 'worldCup.matches[].awayTeamLogo' },
  { label: '赛事列表-主队得分', keys: 'worldCup.matches[].homeTeamScore' },
  { label: '赛事列表-客队得分', keys: 'worldCup.matches[].awayTeamScore' },
  { label: '赛事列表-开赛时间', keys: 'worldCup.matches[].matchTime' },
  { label: '赛事列表-比赛阶段', keys: 'worldCup.matches[].stage' },
  { label: '赛事列表-比赛状态', keys: 'worldCup.matches[].matchStatus' },
  { label: '赛事列表-比赛结果', keys: 'worldCup.matches[].matchResult' },
  { label: '赛事列表-比赛分钟', keys: 'worldCup.matches[].matchMinute' },
  { label: '赛事列表-可用投注选项', keys: 'worldCup.matches[].availableOptions' },
  { label: '赛事日期选项', keys: 'worldCup.dateOptions' },
  { label: '赛事日期选项-日期', keys: 'worldCup.dateOptions[].date' },
  { label: '赛事日期选项-赛事ID列表', keys: 'worldCup.dateOptions[].matchIds' },
  { label: '当前选中日期', keys: 'worldCup.selectedDate' },
  { label: '当前选中日期下标', keys: 'worldCup.selectedDateIndex' },
  { label: '我选择的投注结果', keys: 'worldCup.betResult' },
  { label: '当前选中日期赛事列表', keys: 'worldCup.selectedDateMatches' },
  { label: '选中日期赛事-赛事ID', keys: 'worldCup.selectedDateMatches[].matchId' },
  { label: '选中日期赛事-主队名称', keys: 'worldCup.selectedDateMatches[].homeTeamName' },
  { label: '选中日期赛事-客队名称', keys: 'worldCup.selectedDateMatches[].awayTeamName' },
  { label: '选中日期赛事-主队Logo', keys: 'worldCup.selectedDateMatches[].homeTeamLogo' },
  { label: '选中日期赛事-客队Logo', keys: 'worldCup.selectedDateMatches[].awayTeamLogo' },
  { label: '选中日期赛事-主队得分', keys: 'worldCup.selectedDateMatches[].homeTeamScore' },
  { label: '选中日期赛事-客队得分', keys: 'worldCup.selectedDateMatches[].awayTeamScore' },
  { label: '选中日期赛事-开赛时间', keys: 'worldCup.selectedDateMatches[].matchTime' },
  { label: '选中日期赛事-比赛阶段', keys: 'worldCup.selectedDateMatches[].stage' },
  { label: '选中日期赛事-比赛状态', keys: 'worldCup.selectedDateMatches[].matchStatus' },
  { label: '选中日期赛事-比赛结果', keys: 'worldCup.selectedDateMatches[].matchResult' },
  { label: '选中日期赛事-比赛分钟', keys: 'worldCup.selectedDateMatches[].matchMinute' },
  { label: '选中日期赛事-可用投注选项', keys: 'worldCup.selectedDateMatches[].availableOptions' },
  { label: '选中日期赛事-是否已投注', keys: 'worldCup.selectedDateMatches[].hasBet' },
  { label: '选中日期赛事-奖池总金额', keys: 'worldCup.selectedDateMatches[].poolInfo.totalPool' },
  { label: '选中日期赛事-主胜奖池', keys: 'worldCup.selectedDateMatches[].poolInfo.homeWinPool' },
  { label: '选中日期赛事-平局奖池', keys: 'worldCup.selectedDateMatches[].poolInfo.drawPool' },
  { label: '选中日期赛事-客胜奖池', keys: 'worldCup.selectedDateMatches[].poolInfo.awayWinPool' },
  { label: '选中日期赛事-主胜奖池-比例', keys: 'worldCup.selectedDateMatches[].poolInfo.homeWinPoolRatio' },
  { label: '选中日期赛事-客胜奖池-比例', keys: 'worldCup.selectedDateMatches[].poolInfo.awayWinPoolRatio' },
  { label: '选中日期赛事-平局奖池-比例', keys: 'worldCup.selectedDateMatches[].poolInfo.drawPoolRatio' },
  { label: '选中日期赛事-投注人数', keys: 'worldCup.selectedDateMatches[].poolInfo.bettorCount' },
  { label: '投注记录列表', keys: 'worldCup.records' },
  { label: '投注记录总数', keys: 'worldCup.recordsTotalCount' },
  { label: '投注记录当前页码', keys: 'worldCup.recordsPageNum' },
  { label: '投注记录每页条数', keys: 'worldCup.recordsPageSize' },
  { label: '投注记录-记录ID', keys: 'worldCup.records[].recordId' },
  { label: '投注记录-赛事ID', keys: 'worldCup.records[].matchId' },
  { label: '投注记录-主队名称', keys: 'worldCup.records[].homeTeamName' },
  { label: '投注记录-客队名称', keys: 'worldCup.records[].awayTeamName' },
  { label: '投注记录-主队Logo', keys: 'worldCup.records[].homeTeamLogo' },
  { label: '投注记录-客队Logo', keys: 'worldCup.records[].awayTeamLogo' },
  { label: '投注记录-投注选项', keys: 'worldCup.records[].option' },
  { label: '投注记录-投注金额', keys: 'worldCup.records[].amount' },
  { label: '投注记录-投注时间', keys: 'worldCup.records[].betTime' },
  { label: '投注记录-开赛时间', keys: 'worldCup.records[].matchTime' },
  { label: '投注记录-赛事状态', keys: 'worldCup.records[].matchStatus' },
  { label: '投注记录-比赛结果', keys: 'worldCup.records[].matchResult' },
  { label: '投注记录-投注结果', keys: 'worldCup.records[].result' },
  { label: '投注记录-返还金额', keys: 'worldCup.records[].returnAmount' },
  { label: '投注记录-净收益', keys: 'worldCup.records[].profitAmount' },
  { label: '投注记录-预期返还', keys: 'worldCup.records[].expectedReturn' },
  { label: '我的战绩-我的头像', keys: 'worldCup.battleRecord.icon' },
  { label: '我的战绩-参与场次', keys: 'worldCup.battleRecord.totalMatches' },
  { label: '我的战绩-猜中场次', keys: 'worldCup.battleRecord.winMatches' },
  { label: '我的战绩-胜率', keys: 'worldCup.battleRecord.winRate' },
  { label: '我的战绩-总盈利', keys: 'worldCup.battleRecord.totalProfit' },
  { label: '我的战绩-总亏损', keys: 'worldCup.battleRecord.totalLoss' },
  { label: '我的战绩-累计净收益', keys: 'worldCup.battleRecord.accumulatedProfit' },
  { label: '我的战绩-每日统计', keys: 'worldCup.battleRecord.dailyRecords' },
  { label: '我的战绩-每日统计-日期', keys: 'worldCup.battleRecord.dailyRecords[].date' },
  { label: '我的战绩-每日统计-竞猜场数', keys: 'worldCup.battleRecord.dailyRecords[].matchCount' },
  { label: '我的战绩-每日统计-净收益', keys: 'worldCup.battleRecord.dailyRecords[].profit' },
  { label: '今日排行榜日期', keys: 'worldCup.todayRank.date' },
  { label: '今日排行榜列表', keys: 'worldCup.todayRank.entries' },
  { label: '今日排行榜-排名', keys: 'worldCup.todayRank.entries[].rank' },
  { label: '今日排行榜-玩家ID', keys: 'worldCup.todayRank.entries[].playerId' },
  { label: '今日排行榜-玩家名称', keys: 'worldCup.todayRank.entries[].playerName' },
  { label: '今日排行榜-玩家头像', keys: 'worldCup.todayRank.entries[].playerIcon' },
  { label: '今日排行榜-盈利金额', keys: 'worldCup.todayRank.entries[].profit' },
  { label: '今日我的排名-排名', keys: 'worldCup.todayRank.myRank.rank' },
  { label: '今日我的排名-玩家ID', keys: 'worldCup.todayRank.myRank.playerId' },
  { label: '今日我的排名-玩家名称', keys: 'worldCup.todayRank.myRank.playerName' },
  { label: '今日我的排名-玩家头像', keys: 'worldCup.todayRank.myRank.playerIcon' },
  { label: '今日我的排名-盈利金额', keys: 'worldCup.todayRank.myRank.profit' },
  { label: '今日排行榜-当天是否投注', keys: 'worldCup.todayRank.hasBetToday' },
  { label: '昨日排行榜日期', keys: 'worldCup.yesterdayRank.date' },
  { label: '昨日排行榜列表', keys: 'worldCup.yesterdayRank.entries' },
  { label: '昨日排行榜-排名', keys: 'worldCup.yesterdayRank.entries[].rank' },
  { label: '昨日排行榜-玩家ID', keys: 'worldCup.yesterdayRank.entries[].playerId' },
  { label: '昨日排行榜-玩家名称', keys: 'worldCup.yesterdayRank.entries[].playerName' },
  { label: '昨日排行榜-玩家头像', keys: 'worldCup.yesterdayRank.entries[].playerIcon' },
  { label: '昨日排行榜-盈利金额', keys: 'worldCup.yesterdayRank.entries[].profit' },
  { label: '昨日我的排名-排名', keys: 'worldCup.yesterdayRank.myRank.rank' },
  { label: '昨日我的排名-玩家ID', keys: 'worldCup.yesterdayRank.myRank.playerId' },
  { label: '昨日我的排名-玩家名称', keys: 'worldCup.yesterdayRank.myRank.playerName' },
  { label: '昨日我的排名-玩家头像', keys: 'worldCup.yesterdayRank.myRank.playerIcon' },
  { label: '昨日我的排名-盈利金额', keys: 'worldCup.yesterdayRank.myRank.profit' },
  { label: '昨日排行榜-当天是否投注', keys: 'worldCup.yesterdayRank.hasBetToday' }
]

export const API = {
  /** 获取代币余额 ReqId: 1 */
  getCurrencyBalance: (ids) => {
    if (AppReq.requestUnityApi) {
      return AppReq.requestUnityApi('1', { ids })
    }
    return null
  },
  /** 赛事列表 ReqId: 33 */
  getMatchList: (activityId) => {
    if (AppReq.requestUnityApi) {
      return AppReq.requestUnityApi('33', { activityId })
    }
    return null
  },
  /** 投注 ReqId: 34 */
  placeBet: (params) => {
    if (AppReq.requestUnityApi) {
      return AppReq.requestUnityApi('34', params)
    }
    return null
  },
  /** 投注记录 ReqId: 35 */
  getBetRecords: (params) => {
    if (AppReq.requestUnityApi) {
      return AppReq.requestUnityApi('35', params)
    }
    return null
  },
  /** 我的战绩 ReqId: 36 */
  getBattleRecord: (activityId) => {
    if (AppReq.requestUnityApi) {
      return AppReq.requestUnityApi('36', { activityId })
    }
    return null
  },
  /** 排行榜 ReqId: 37 */
  getRankList: (activityId, date) => {
    if (AppReq.requestUnityApi) {
      const req = { activityId }
      if (date) req.date = date
      return AppReq.requestUnityApi('37', req)
    }
    return null
  },
  /** 赛事投注信息 ReqId: 38 */
  getMatchPoolInfo: (activityId, matchIds) => {
    if (AppReq.requestUnityApi) {
      return AppReq.requestUnityApi('38', { activityId, matchIds })
    }
    return null
  }
}

const getResponseCode = (data) => {
  if (data?.code !== undefined) return data.code
  if (data?.status !== undefined) return data.status
  return 1
}

const isSuccess = (data) => getResponseCode(data) === SUCCESS_CODE

const syncDataSource = (state, appStore) => {
  appStore?.setPageDataSource(state.uuid, state.dataSource || null)
}

/** 获取服务器校准后的当前时间戳 */
const getServerTime = (appStore) => {
  const timeInfo = appStore?.getPageDataSource('data-source_timeInfo')
  let currentTime = Date.now()
  if (timeInfo?.serverTime && timeInfo?.localTime) {
    currentTime = Date.now() + (Number(timeInfo.serverTime) - Number(timeInfo.localTime))
  }
  return currentTime
}

/** matchTime 毫秒时间戳 → MM-DD HH:MM */
export const formatMatchTimeStr = (matchTime) => {
  const d = new Date(Number(matchTime))
  const month = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  const hours = String(d.getHours()).padStart(2, '0')
  const minutes = String(d.getMinutes()).padStart(2, '0')
  return `${month}-${day} ${hours}:${minutes}`
}

/** matchTime 毫秒时间戳 → M:DD（月不补零，日两位） */
export const formatMatchDateKey = (matchTime) => {
  const d = new Date(Number(matchTime))
  const month = d.getMonth() + 1
  const day = String(d.getDate()).padStart(2, '0')
  return `${month}-${day}`
}

/** 时间戳 → yyyyMMdd */
export const formatDateYyyyMMdd = (timestamp) => {
  const d = new Date(Number(timestamp))
  const year = d.getFullYear()
  const month = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${year}${month}${day}`
}

/** 计算奖池占比：各奖池 / 总金额 * 100 取整，合计不为 100 时在平局比例上补差，并追加 % */
export const computePoolRatios = (poolInfo) => {
  if (!poolInfo) return

  const totalPool = Number(poolInfo.totalPool) || 0
  const homeWinPool = Number(poolInfo.homeWinPool) || 0
  const drawPool = Number(poolInfo.drawPool) || 0
  const awayWinPool = Number(poolInfo.awayWinPool) || 0

  if (totalPool <= 0) {
    poolInfo.homeWinPoolRatio = '0%'
    poolInfo.drawPoolRatio = '0%'
    poolInfo.awayWinPoolRatio = '0%'
    return
  }

  let homeRatio = Math.round((homeWinPool / totalPool) * 100)
  let drawRatio = Math.round((drawPool / totalPool) * 100)
  let awayRatio = Math.round((awayWinPool / totalPool) * 100)

  const diff = 100 - (homeRatio + drawRatio + awayRatio)
  if (diff !== 0) {
    drawRatio += diff
  }

  poolInfo.homeWinPoolRatio = `${homeRatio}%`
  poolInfo.awayWinPoolRatio = `${awayRatio}%`
  poolInfo.drawPoolRatio = `${drawRatio}%`
}

/** 按开赛日期分组，生成日期选项 [{ date, matchIds }] */
export const buildDateOptions = (matches = []) => {
  const sorted = [...matches].sort((a, b) => Number(a.matchTime) - Number(b.matchTime))
  const dateOrder = []
  const dateMap = new Map()

  sorted.forEach((match) => {
    const date = formatMatchDateKey(match.matchTime)
    if (!dateMap.has(date)) {
      dateMap.set(date, [])
      dateOrder.push(date)
    }
    dateMap.get(date).push(match.matchId)
  })

  return dateOrder.map((date) => ({ date, matchIds: dateMap.get(date) }))
}

/** M:DD → 可比较的数值（同一年内按序比较） */
const parseDateKey = (dateKey) => {
  const [month, day] = String(dateKey).split('-').map(Number)
  return month * 100 + day
}

/** 默认选中：优先当天；否则选 dateOptions 中最近的下一天；若均已过去则选最后一天 */
export const resolveDefaultSelectedDate = (dateOptions = [], now = Date.now()) => {
  if (!dateOptions.length) return ''

  const today = formatMatchDateKey(now)
  const sortedDates = dateOptions.map((item) => item.date).sort((a, b) => parseDateKey(a) - parseDateKey(b))

  if (sortedDates.includes(today)) {
    return today
  }

  const todayNum = parseDateKey(today)
  const nextDay = sortedDates.find((date) => parseDateKey(date) > todayNum)
  if (nextDay) {
    return nextDay
  }

  return sortedDates[sortedDates.length - 1]
}

export const useWorldCup = (props) => {
  const componentRef = ref(null)
  const appStore = useAppStore ? useAppStore() : null
  const { getComponentRef } = useComponentRef()
  let hasInitializedSelectedDate = false
  // let hasLoadedBetRecords = false
  let hasLoadedTodayRankList = false
  let hasLoadedYesterdayRankList = false

  const showFirstLoadLoading = () => {
    if (import.meta.env.VITE_APP_TAG === 'H5' && Loading?.show) {
      Loading.show()
    }
  }

  const hideFirstLoadLoading = () => {
    if (import.meta.env.VITE_APP_TAG === 'H5' && Loading?.hide) {
      Loading.hide()
    }
  }

  const state = reactive({
    language: 'en',
    uuid: '',
    dataSource: {
      worldCup: {
        currencyId: null,
        currencyBalance: 0,
        minBetAmount: 0,
        matches: [],
        dateOptions: [],
        selectedDate: '',
        selectedDateIndex: -1,
        betResult: 'HOME_WIN',
        selectedDateMatches: [],
        records: [],
        recordsTotalCount: 0,
        recordsPageNum: 1,
        recordsPageSize: 20,
        battleRecord: {
          dailyRecords: []
        },
        todayRank: {
          date: '',
          entries: [],
          myRank: null,
          hasBetToday: false
        },
        yesterdayRank: {
          date: '',
          entries: [],
          myRank: null,
          hasBetToday: false
        }
      }
    }
  })

  const showErrorTips = (code) => {
    let msg = 'error: ' + code
    if (WORLD_CUP_ERROR_CODES.includes(Number(code))) {
      msg = LGSdk.t(`worldCup.${code}`)
    }
    Toast && Toast({ message: msg, duration: 1500 })
  }

  const fetchSelectedDateMatchPoolInfo = async () => {
    console.time('获取赛事投注信息----->')
    const { selectedDateMatches } = state.dataSource.worldCup
    if (!props.activityId || !selectedDateMatches?.length) return

    const matchIds = selectedDateMatches.map((match) => match.matchId)
    try {
      console.time('获取赛事投注信息-接口----->')
      const res = await API.getMatchPoolInfo(props.activityId, matchIds)
      console.timeEnd('获取赛事投注信息-接口----->')
      await handleResponse(res, (data) => {
        const poolMap = new Map((data.matches || []).map((item) => [item.matchId, item]))
        selectedDateMatches.forEach((match) => {
          const poolData = poolMap.get(match.matchId)
          if (poolData) {
            match.poolInfo = poolData.poolInfo
            computePoolRatios(match.poolInfo)
            match.hasBet = poolData.hasBet
          }
        })
      })
    } catch (e) {
      console.error(e)
    }
    console.timeEnd('获取赛事投注信息----->')
  }

  const updateSelectedDateMatches = async () => {
    const { selectedDate, matches } = state.dataSource.worldCup
    if (!selectedDate) {
      state.dataSource.worldCup.selectedDateMatches = []
      return
    }
    state.dataSource.worldCup.selectedDateMatches = (matches || [])
      .filter((match) => formatMatchDateKey(match.matchTime) === selectedDate)
      .sort((a, b) => {
        const aIsLast = Number(a.matchStatus) !== 0 && Number(a.matchStatus) !== 1
        const bIsLast = Number(b.matchStatus) !== 0 && Number(b.matchStatus) !== 1
        if (aIsLast === bIsLast) return 0
        return aIsLast ? 1 : -1
      })
    await fetchSelectedDateMatchPoolInfo()
  }

  /** 开赛时间已到且仍为未开赛(0)时，同步为进行中(1) */
  const syncSelectedDateMatchStatusByServerTime = () => {
    const { selectedDateMatches } = state.dataSource.worldCup
    if (!selectedDateMatches?.length) return

    const now = getServerTime(appStore)
    let hasUpdated = false

    selectedDateMatches.forEach((match) => {
      if (Number(match.matchStatus) === 0 && Number(match.matchTime) < now) {
        match.matchStatus = 1
        hasUpdated = true
      }
    })

    if (hasUpdated) {
      syncDataSource(state, appStore)
    }
  }

  const resolveSelectedDateIndex = (selectedDate, dateOptions = []) => {
    if (!selectedDate || !dateOptions.length) return -1
    return dateOptions.findIndex((item) => item.date === selectedDate)
  }

  /** 渲染完成后滚动日期列表到当前选中项 */
  const scrollToSelectedDateListItem = async () => {
    if (import.meta.env.VITE_APP_TAG !== 'H5') return
    if (!props.dateListItemLayoutUUID) return

    const { selectedDateIndex } = state.dataSource.worldCup
    if (selectedDateIndex < 0) return

    await nextTick()
    await nextTick()
    getComponentRef(props.dateListItemLayoutUUID)?.scrollToIndex?.(selectedDateIndex)
  }

  const syncMatchDateData = async (matches, { autoSelect = false } = {}) => {
    const dateOptions = buildDateOptions(matches)
    state.dataSource.worldCup.dateOptions = dateOptions
    const now = getServerTime(appStore)

    if (autoSelect && !hasInitializedSelectedDate) {
      state.dataSource.worldCup.selectedDate = resolveDefaultSelectedDate(dateOptions, now)
      hasInitializedSelectedDate = true
    } else if (state.dataSource.worldCup.selectedDate && !dateOptions.some((item) => item.date === state.dataSource.worldCup.selectedDate)) {
      state.dataSource.worldCup.selectedDate = resolveDefaultSelectedDate(dateOptions, now)
    }

    state.dataSource.worldCup.selectedDateIndex = resolveSelectedDateIndex(state.dataSource.worldCup.selectedDate, dateOptions)
    await updateSelectedDateMatches()
    syncDataSource(state, appStore)
    await scrollToSelectedDateListItem()
  }

  const setSelectedDate = async (params = {}) => {
    console.time('选择日期----->')
    const { date } = params
    if (!date) return
    showFirstLoadLoading()
    try {
      state.dataSource.worldCup.selectedDate = date
      state.dataSource.worldCup.selectedDateIndex = resolveSelectedDateIndex(date, state.dataSource.worldCup.dateOptions)
      await updateSelectedDateMatches()
      syncDataSource(state, appStore)
      await scrollToSelectedDateListItem()
    } finally {
      hideFirstLoadLoading()
    }
    console.timeEnd('选择日期----->')
  }

  const getDateSwitchLength = () => {
    const length = Number(props.dateSwitchLength)
    return Number.isFinite(length) && length > 0 ? Math.floor(length) : 5
  }

  const selectDateByIndex = async (index) => {
    const { dateOptions } = state.dataSource.worldCup
    if (!dateOptions?.length || index < 0 || index >= dateOptions.length) return false
    await setSelectedDate({ date: dateOptions[index].date })
    return true
  }

  /** 上一页日期：当前选中下标减去日期切换长度，不超出范围 */
  const prevDatePage = async () => {
    const { selectedDateIndex, dateOptions } = state.dataSource.worldCup
    if (!dateOptions?.length) return

    const step = getDateSwitchLength()
    const currentIndex = selectedDateIndex >= 0 ? selectedDateIndex : 0
    const newIndex = Math.max(0, currentIndex - step)
    if (newIndex === currentIndex) return

    await selectDateByIndex(newIndex)
  }

  /** 下一页日期：当前选中下标加上日期切换长度，不超出范围 */
  const nextDatePage = async () => {
    const { selectedDateIndex, dateOptions } = state.dataSource.worldCup
    if (!dateOptions?.length) return

    const step = getDateSwitchLength()
    const maxIndex = dateOptions.length - 1
    const currentIndex = selectedDateIndex >= 0 ? selectedDateIndex : 0
    const newIndex = Math.min(maxIndex, currentIndex + step)
    if (newIndex === currentIndex) return

    await selectDateByIndex(newIndex)
  }

  const setBetResult = async (params = {}) => {
    const { option } = params
    if (!option || !BET_OPTIONS.includes(option)) {
      return
    }
    state.dataSource.worldCup.betResult = option
    syncDataSource(state, appStore)
  }

  const handleResponse = async (res, onSuccess) => {
    const data = res?.data
    if (!isSuccess(data)) {
      showErrorTips(getResponseCode(data))
      syncDataSource(state, appStore)
      return false
    }
    await onSuccess?.(data)
    syncDataSource(state, appStore)
    return true
  }

  const fetchCurrencyBalance = async () => {
    const { currencyId } = state.dataSource.worldCup
    if (currencyId === null || currencyId === undefined) return
    try {
      const res = await API.getCurrencyBalance(currencyId)
      await handleResponse(res, (data) => {
        state.dataSource.worldCup.currencyBalance = data.list?.[0]?.count ?? 0
      })
    } catch (e) {
      console.error(e)
    }
  }

  const refreshCurrencyBalance = async () => {
    await fetchCurrencyBalance()
  }

  const getMatchList = async () => {
    if (!props.activityId) return
    try {
      const res = await API.getMatchList(props.activityId)
      await handleResponse(res, async (data) => {
        const matches = data.matches || []
        state.dataSource.worldCup.currencyId = data.currencyId ?? null
        state.dataSource.worldCup.minBetAmount = data.minBetAmount ?? 0
        state.dataSource.worldCup.matches = matches
        await fetchCurrencyBalance()
        await syncMatchDateData(matches, { autoSelect: !hasInitializedSelectedDate })
      })
    } catch (e) {
      console.error(e)
    }
  }

  const placeBet = async (params = {}) => {
    const { matchId, amount } = params
    const { betResult, minBetAmount, currencyBalance } = state.dataSource.worldCup
    const option = betResult || 'HOME_WIN'
    const betAmount = Number(amount)

    if (!props.activityId) {
      return
    }
    if (!matchId || amount === undefined || amount === null || Number.isNaN(betAmount)) {
      throw new Error(`worldCup.4300007}`)
    }
    if (betAmount < Number(minBetAmount || 0)) {
      Toast && Toast({ message: LGSdk.t('worldCup.minBetAmount', { minBetAmount: minBetAmount }), duration: 1500 })
      throw new Error(`worldCup.4300007`)
    }
    if (betAmount > Number(currencyBalance || 0)) {
      Toast && Toast({ message: LGSdk.t(`worldCup.moreAmount`), duration: 1500 })
      throw new Error(`worldCup.4300007}`)
    }
    const res = await API.placeBet({
      activityId: props.activityId,
      matchId,
      option,
      amount: betAmount
    })
    const ok = await handleResponse(res)

    console.log('------placeBet------', ok)
    if (ok) {
      await fetchCurrencyBalance()
    } else {
      throw new Error(`worldCup.${getResponseCode(res.data)}`)
    }
  }

  const getBetRecords = async () => {
    if (!props.activityId) return
    try {
      const pageSize = state.dataSource.worldCup.recordsPageSize || 20
      const req = { activityId: props.activityId, pageNum: 1, pageSize }
      const res = await API.getBetRecords(req)
      await handleResponse(res, (data) => {
        state.dataSource.worldCup.records = data.records || []
        state.dataSource.worldCup.recordsTotalCount = data.totalCount ?? 0
        state.dataSource.worldCup.recordsPageNum = data.pageNum ?? req.pageNum
        state.dataSource.worldCup.recordsPageSize = data.pageSize ?? req.pageSize
      })
    } catch (e) {
      console.error(e)
    }
  }

  /** 获取投注记录下一页，自行维护分页状态，无需传参 */
  const getBetRecordsNextPage = async () => {
    if (!props.activityId) return

    const { records, recordsPageNum, recordsPageSize, recordsTotalCount } = state.dataSource.worldCup
    if (records?.length >= recordsTotalCount) return

    const nextPageNum = (recordsPageNum || 1) + 1
    const pageSize = recordsPageSize || 20

    console.time('获取投注记录下一页----->')
    showFirstLoadLoading()
    try {
      const req = { activityId: props.activityId, pageNum: nextPageNum, pageSize }
      const res = await API.getBetRecords(req)
      await handleResponse(res, (data) => {
        const newRecords = data.records || []
        if (!newRecords.length) return
        state.dataSource.worldCup.records = [...(records || []), ...newRecords]
        state.dataSource.worldCup.recordsTotalCount = data.totalCount ?? recordsTotalCount
        state.dataSource.worldCup.recordsPageNum = data.pageNum ?? nextPageNum
        state.dataSource.worldCup.recordsPageSize = data.pageSize ?? pageSize
      })
    } catch (e) {
      console.error(e)
    } finally {
      hideFirstLoadLoading()
    }
    console.timeEnd('获取投注记录下一页----->')
  }

  const getBattleRecord = async () => {
    if (!props.activityId) return
    try {
      const res = await API.getBattleRecord(props.activityId)
      await handleResponse(res, (data) => {
        state.dataSource.worldCup.battleRecord = {
          totalMatches: data.totalMatches,
          winMatches: data.winMatches,
          winRate: data.winRate,
          totalProfit: data.totalProfit,
          totalLoss: data.totalLoss,
          accumulatedProfit: data.accumulatedProfit,
          dailyRecords: data.dailyRecords || [],
          icon: data.icon || ''
        }
      })
    } catch (e) {
      console.error(e)
    }
  }

  const fetchRankList = async (date, rankKey, { isFirstLoad = false } = {}) => {
    if (!props.activityId) return
    if (isFirstLoad) showFirstLoadLoading()
    try {
      const res = await API.getRankList(props.activityId, date)
      await handleResponse(res, (data) => {
        state.dataSource.worldCup[rankKey] = {
          date: data.date || date,
          entries: data.entries || [],
          myRank: data.myRank || null,
          hasBetToday: data.hasBetToday ?? false
        }
      })
    } catch (e) {
      console.error(e)
    } finally {
      if (isFirstLoad) hideFirstLoadLoading()
    }
  }

  const getTodayRankList = async () => {
    const isFirstLoad = !hasLoadedTodayRankList
    const today = formatDateYyyyMMdd(getServerTime(appStore))
    await fetchRankList(today, 'todayRank', { isFirstLoad })
    if (isFirstLoad) hasLoadedTodayRankList = true
  }

  const getYesterdayRankList = async () => {
    const isFirstLoad = !hasLoadedYesterdayRankList
    const yesterday = formatDateYyyyMMdd(getServerTime(appStore) - 24 * 60 * 60 * 1000)
    await fetchRankList(yesterday, 'yesterdayRank', { isFirstLoad })
    if (isFirstLoad) hasLoadedYesterdayRankList = true
  }

  const init = async () => {
    showFirstLoadLoading()
    try {
      await getMatchList()
      getBetRecords()
      getTodayRankList()
      // getBattleRecord()
      // await getBattleRecord()
    } finally {
      hideFirstLoadLoading()
    }
  }

  useGlobalTimer(() => {
    if (import.meta.env.VITE_APP_TAG === 'H5') {
      syncSelectedDateMatchStatusByServerTime()
    }
  })

  onMounted(() => {
    if (componentRef.value) {
      state.language = componentRef.value.getAttribute('language') || 'en'
      state.uuid = componentRef.value.getAttribute('id') || ''
    }
    if (import.meta.env.VITE_APP_TAG === 'H5') {
      init()
    }
  })

  return {
    componentRef,
    getMatchList,
    placeBet,
    getBetRecords,
    getBetRecordsNextPage,
    getBattleRecord,
    getTodayRankList,
    getYesterdayRankList,
    setSelectedDate,
    prevDatePage,
    nextDatePage,
    setBetResult,
    refreshCurrencyBalance
  }
}
